import { AxiosError } from 'axios';
import { BulkActivationResultItemDTO } from 'probonio-shared-ui/api';

export function extractBulkErrorResults(err: unknown): BulkActivationResultItemDTO[] | undefined {
  if (!(err instanceof AxiosError) || err.response?.status !== 422) {
    return undefined;
  }
  const data: unknown = err.response.data?.data;
  return Array.isArray(data) ? (data as BulkActivationResultItemDTO[]) : undefined;
}
